/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import * as ReactDnD from 'react-dnd';

class SortableList extends React.Component {
  static initClass() {
    this.propTypes = {
      // Identifier for this list (used for drag types)
      listIdentifier: PropTypes.string.isRequired,
      // Callback for drag hover
      onDragUpdate: PropTypes.func
    };
  }

  constructor(props) {
    super(props);
  }

  render() {
    const ul_props = _.omit(this.props, 'listIdentifier', 'onDragUpdate', 'hovered', 'connectDropTarget');
    return this.props.connectDropTarget(<ul {...ul_props}>
      {this.props.children}
    </ul>
    );
  }
}
SortableList.initClass();


const dropSpec = {
  drop(props, monitor, component) {
    if (!monitor.didDrop()) { return {position: 'end'}; }
  },

  hover(props, monitor, component) {
    if (monitor.canDrop() && monitor.isOver({shallow: true})) {
      const item = monitor.getItem();
      return (typeof props.onDragUpdate === 'function' ? props.onDragUpdate(item, 'end') : undefined);
    }
  }
};

const dropCollect = (connect, monitor) => ({
  hovered: monitor.isOver(),
  connectDropTarget: connect.dropTarget()
});

const dropTypes = props => props.listIdentifier;

export const SortableListContainer = ReactDnD.DropTarget(dropTypes, dropSpec, dropCollect)(SortableList);